import styled from 'styled-components';

import { body } from '@constants/fonts';

export const DropdownStyle = styled.div`
  border-radius: 17px;
  background-color: ${({ theme }) => theme.palette.background.paper}36;
  position: relative;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  transition: border-radius 0.1s linear;
  display: flex;
  justify-content: center;
  width: fit-content;

  &.open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const Selector = styled.div`
  font-weight: 600;
  height: 34px;
  width: 135px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0 20px;
  box-sizing: border-box;

  font-size: 14px;
  font-family: ${body};

  @media (max-width: 395px) {
    width: 100px;
  }
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.text.primary};
  position: absolute;
  top: 34px;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  visibility: hidden;

  transition: border-radius 0.1s linear;

  &.open {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    visibility: visible;
  }
`;

export const Option = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.paper};

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.paper}BB;
  }
`;
